import { logger } from 'helpers'
var dashboard = {}
try {
  dashboard = require('../projects/' + process.env.REACT_APP_PROJECT + '/config/dashboard')
} catch (e) {
  logger.debug('No project-specific config for dashboard')
}
module.exports = dashboard



// WEBPACK FOOTER //
// ./src/config/dashboard.js